import api from "@services/api";

/** Decimal degrees. */
export type Coordinates = { lat: number; lng: number };

/** A Seqwater dam's latest reading, as Seqwater publishes it. */
export type DamLevel = {
  /** Seqwater's slug, e.g. "bill-gunn-lake-dyer". */
  id: string;
  name: string;
  /** Litres. */
  fullSupplyVolume: number;
  /** Litres. */
  currentVolume: number;
  /** Seqwater's own figure; over 100 while the dam spills. */
  percentFull: number;
  observedAt: string;
  /** e.g. "Dam is spilling". */
  comment: string | null;
  lat: number | null;
  lng: number | null;
};

/** Seqwater's dams; given a point, nearest first. */
export const getDamLevels = async (near?: Coordinates): Promise<DamLevel[]> => {
  const { data } = await api.get("/damLevels", { params: near });
  return data;
};
